import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { getAllEntretiens, getInfosSalarie } from "../../actions/salarie/actions_salarie_1";
import { closeDrawer } from "../../actions/shared/actions_shared_1";
import NoMatch from "./../shared/pages/NoMatch";
import CustomAppBar from "./../shared/utils/CustomAppBar";
import PrivateRoute from './../shared/utils/PrivateRoute';
import BibliothequeDesCompetencesSalarie from "./bodies/BibliothequeDesCompetencesSalarie";
import EntretiensSalarie from "./bodies/EntretiensSalarie";
import FormationsSalarie from "./bodies/FormationsSalarie";
import IndexBody from './bodies/IndexBody';
import InfosPersosSalarie from "./bodies/InfosPersosSalarie";
import PlansActionSalarie from "./bodies/PlansActionSalarie";
import PostesDisponibles from "./bodies/PostesDisponibles";
import ProjetProSalarie from "./bodies/ProjetProSalarie";
import SalarieDrawer from "./SalarieDrawer";

class SalarieIndex extends Component {

    componentDidMount() {
        this.props.dispatch(getInfosSalarie());
        this.props.dispatch(getAllEntretiens());
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.props.dispatch(closeDrawer());
        }
    }

    render() {
        const email = this.props.infos.email;
        const budget_cpf = this.props.infos.budget_cpf;
        return (
            <div className="salarie-container">
                <SalarieDrawer history={this.props.history} />
                <CustomAppBar
                    titlePath='/salarie'
                    hideLeftBtn={true}
                    history={this.props.history}
                    title={this.props.infos.nom + " " + this.props.infos.prenom}
                    dispatch={this.props.dispatch} />

                <Switch>
                    <PrivateRoute exact path="/salarie" component={IndexBody} />
                    <PrivateRoute exact path="/salarie/infos-personnelles"
                        component={(props) =>
                            <InfosPersosSalarie
                                dispatch={this.props.dispatch}
                                email={email}
                                budget_cpf={budget_cpf}
                            />
                        }
                    />
                    <PrivateRoute exact path="/salarie/postes_disponibles" component={PostesDisponibles} />
                    <PrivateRoute exact path="/salarie/entretiens" component={EntretiensSalarie} />
                    <PrivateRoute exact path="/salarie/formations" component={FormationsSalarie} />
                    <PrivateRoute exact path="/salarie/projet-pro" component={ProjetProSalarie} />
                    <PrivateRoute exact path="/salarie/plans-action" component={PlansActionSalarie} />
                    <PrivateRoute exact path="/salarie/bibliotheque-des-competences"
                        component={BibliothequeDesCompetencesSalarie} />
                    <Route component={NoMatch} />
                </Switch>
            </div>
        );
    }

}

function mapStateToProps(store) {
    return { infos: store.salarie.infos }
}

export default connect(mapStateToProps)(SalarieIndex);


// WEBPACK FOOTER //
// ./src/components/salarie/index.js